/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as InvitationRouteImport } from './routes/invitation'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PublicVerifyRouteImport } from './routes/_public/verify'
import { Route as PublicSignupRouteImport } from './routes/_public/signup'
import { Route as PublicResetPasswordRouteImport } from './routes/_public/reset-password'
import { Route as PublicLoginRouteImport } from './routes/_public/login'
import { Route as AuthenticatedLogoutRouteImport } from './routes/_authenticated/logout'
import { Route as AuthenticatedScheduleIndexRouteImport } from './routes/_authenticated/schedule/index'
import { Route as AuthenticatedMemberIndexRouteImport } from './routes/_authenticated/member/index'
import { Route as AuthenticatedMeIndexRouteImport } from './routes/_authenticated/me/index'
import { Route as AuthenticatedDashboardIndexRouteImport } from './routes/_authenticated/dashboard/index'
import { Route as PublicOrganizationNewRouteImport } from './routes/_public/organization/new'
import { Route as PublicOrganizationJoinRouteImport } from './routes/_public/organization/join'
import { Route as PublicAuthGoogleRouteImport } from './routes/_public/auth.google'
import { Route as AuthenticatedUserEditRouteImport } from './routes/_authenticated/user/edit'
import { Route as AuthenticatedScheduleCreateRouteImport } from './routes/_authenticated/schedule/create'
import { Route as AuthenticatedScheduleScheduleIdRouteImport } from './routes/_authenticated/schedule/$scheduleId'
import { Route as AuthenticatedOrganizationIntegrationRouteImport } from './routes/_authenticated/organization/integration'
import { Route as AuthenticatedOrganizationEditRouteImport } from './routes/_authenticated/organization/edit'
import { Route as AuthenticatedOrganizationBillingRouteImport } from './routes/_authenticated/organization/billing'
import { Route as AuthenticatedMeFeedbackRouteImport } from './routes/_authenticated/me/feedback'
import { Route as AuthenticatedUserEditSecurityRouteImport } from './routes/_authenticated/user/edit.security'
import { Route as AuthenticatedUserEditAccountRouteImport } from './routes/_authenticated/user/edit.account'
import { Route as AuthenticatedScheduleScheduleIdEditRouteImport } from './routes/_authenticated/schedule/$scheduleId.edit'
import { Route as AuthenticatedScheduleScheduleIdDetailsRouteImport } from './routes/_authenticated/schedule/$scheduleId.details'
import { Route as AuthenticatedScheduleScheduleIdAutomationsRouteImport } from './routes/_authenticated/schedule/$scheduleId.automations'
import { Route as AuthenticatedScheduleScheduleIdAnalyticsRouteImport } from './routes/_authenticated/schedule/$scheduleId.analytics'

const InvitationRoute = InvitationRouteImport.update({
  id: '/invitation',
  path: '/invitation',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicVerifyRoute = PublicVerifyRouteImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => PublicRoute,
} as any)
const PublicSignupRoute = PublicSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => PublicRoute,
} as any)
const PublicResetPasswordRoute = PublicResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => PublicRoute,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRoute,
} as any)
const AuthenticatedLogoutRoute = AuthenticatedLogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedScheduleIndexRoute =
  AuthenticatedScheduleIndexRouteImport.update({
    id: '/schedule/',
    path: '/schedule/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMemberIndexRoute =
  AuthenticatedMemberIndexRouteImport.update({
    id: '/member/',
    path: '/member/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMeIndexRoute = AuthenticatedMeIndexRouteImport.update({
  id: '/me/',
  path: '/me/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardIndexRoute =
  AuthenticatedDashboardIndexRouteImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const PublicOrganizationNewRoute = PublicOrganizationNewRouteImport.update({
  id: '/organization/new',
  path: '/organization/new',
  getParentRoute: () => PublicRoute,
} as any)
const PublicOrganizationJoinRoute = PublicOrganizationJoinRouteImport.update({
  id: '/organization/join',
  path: '/organization/join',
  getParentRoute: () => PublicRoute,
} as any)
const PublicAuthGoogleRoute = PublicAuthGoogleRouteImport.update({
  id: '/auth/google',
  path: '/auth/google',
  getParentRoute: () => PublicRoute,
} as any)
const AuthenticatedUserEditRoute = AuthenticatedUserEditRouteImport.update({
  id: '/user/edit',
  path: '/user/edit',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedScheduleCreateRoute =
  AuthenticatedScheduleCreateRouteImport.update({
    id: '/schedule/create',
    path: '/schedule/create',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedScheduleScheduleIdRoute =
  AuthenticatedScheduleScheduleIdRouteImport.update({
    id: '/schedule/$scheduleId',
    path: '/schedule/$scheduleId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrganizationIntegrationRoute =
  AuthenticatedOrganizationIntegrationRouteImport.update({
    id: '/organization/integration',
    path: '/organization/integration',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrganizationEditRoute =
  AuthenticatedOrganizationEditRouteImport.update({
    id: '/organization/edit',
    path: '/organization/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrganizationBillingRoute =
  AuthenticatedOrganizationBillingRouteImport.update({
    id: '/organization/billing',
    path: '/organization/billing',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMeFeedbackRoute = AuthenticatedMeFeedbackRouteImport.update({
  id: '/me/feedback',
  path: '/me/feedback',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedUserEditSecurityRoute =
  AuthenticatedUserEditSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => AuthenticatedUserEditRoute,
  } as any)
const AuthenticatedUserEditAccountRoute =
  AuthenticatedUserEditAccountRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => AuthenticatedUserEditRoute,
  } as any)
const AuthenticatedScheduleScheduleIdEditRoute =
  AuthenticatedScheduleScheduleIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedScheduleScheduleIdRoute,
  } as any)
const AuthenticatedScheduleScheduleIdDetailsRoute =
  AuthenticatedScheduleScheduleIdDetailsRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () => AuthenticatedScheduleScheduleIdRoute,
  } as any)
const AuthenticatedScheduleScheduleIdAutomationsRoute =
  AuthenticatedScheduleScheduleIdAutomationsRouteImport.update({
    id: '/automations',
    path: '/automations',
    getParentRoute: () => AuthenticatedScheduleScheduleIdRoute,
  } as any)
const AuthenticatedScheduleScheduleIdAnalyticsRoute =
  AuthenticatedScheduleScheduleIdAnalyticsRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => AuthenticatedScheduleScheduleIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/invitation': typeof InvitationRoute
  '/logout': typeof AuthenticatedLogoutRoute
  '/login': typeof PublicLoginRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/signup': typeof PublicSignupRoute
  '/verify': typeof PublicVerifyRoute
  '/me/feedback': typeof AuthenticatedMeFeedbackRoute
  '/organization/billing': typeof AuthenticatedOrganizationBillingRoute
  '/organization/edit': typeof AuthenticatedOrganizationEditRoute
  '/organization/integration': typeof AuthenticatedOrganizationIntegrationRoute
  '/schedule/$scheduleId': typeof AuthenticatedScheduleScheduleIdRouteWithChildren
  '/schedule/create': typeof AuthenticatedScheduleCreateRoute
  '/user/edit': typeof AuthenticatedUserEditRouteWithChildren
  '/auth/google': typeof PublicAuthGoogleRoute
  '/organization/join': typeof PublicOrganizationJoinRoute
  '/organization/new': typeof PublicOrganizationNewRoute
  '/dashboard': typeof AuthenticatedDashboardIndexRoute
  '/me': typeof AuthenticatedMeIndexRoute
  '/member': typeof AuthenticatedMemberIndexRoute
  '/schedule': typeof AuthenticatedScheduleIndexRoute
  '/schedule/$scheduleId/analytics': typeof AuthenticatedScheduleScheduleIdAnalyticsRoute
  '/schedule/$scheduleId/automations': typeof AuthenticatedScheduleScheduleIdAutomationsRoute
  '/schedule/$scheduleId/details': typeof AuthenticatedScheduleScheduleIdDetailsRoute
  '/schedule/$scheduleId/edit': typeof AuthenticatedScheduleScheduleIdEditRoute
  '/user/edit/account': typeof AuthenticatedUserEditAccountRoute
  '/user/edit/security': typeof AuthenticatedUserEditSecurityRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/invitation': typeof InvitationRoute
  '/logout': typeof AuthenticatedLogoutRoute
  '/login': typeof PublicLoginRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/signup': typeof PublicSignupRoute
  '/verify': typeof PublicVerifyRoute
  '/me/feedback': typeof AuthenticatedMeFeedbackRoute
  '/organization/billing': typeof AuthenticatedOrganizationBillingRoute
  '/organization/edit': typeof AuthenticatedOrganizationEditRoute
  '/organization/integration': typeof AuthenticatedOrganizationIntegrationRoute
  '/schedule/$scheduleId': typeof AuthenticatedScheduleScheduleIdRouteWithChildren
  '/schedule/create': typeof AuthenticatedScheduleCreateRoute
  '/user/edit': typeof AuthenticatedUserEditRouteWithChildren
  '/auth/google': typeof PublicAuthGoogleRoute
  '/organization/join': typeof PublicOrganizationJoinRoute
  '/organization/new': typeof PublicOrganizationNewRoute
  '/dashboard': typeof AuthenticatedDashboardIndexRoute
  '/me': typeof AuthenticatedMeIndexRoute
  '/member': typeof AuthenticatedMemberIndexRoute
  '/schedule': typeof AuthenticatedScheduleIndexRoute
  '/schedule/$scheduleId/analytics': typeof AuthenticatedScheduleScheduleIdAnalyticsRoute
  '/schedule/$scheduleId/automations': typeof AuthenticatedScheduleScheduleIdAutomationsRoute
  '/schedule/$scheduleId/details': typeof AuthenticatedScheduleScheduleIdDetailsRoute
  '/schedule/$scheduleId/edit': typeof AuthenticatedScheduleScheduleIdEditRoute
  '/user/edit/account': typeof AuthenticatedUserEditAccountRoute
  '/user/edit/security': typeof AuthenticatedUserEditSecurityRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/invitation': typeof InvitationRoute
  '/_authenticated/logout': typeof AuthenticatedLogoutRoute
  '/_public/login': typeof PublicLoginRoute
  '/_public/reset-password': typeof PublicResetPasswordRoute
  '/_public/signup': typeof PublicSignupRoute
  '/_public/verify': typeof PublicVerifyRoute
  '/_authenticated/me/feedback': typeof AuthenticatedMeFeedbackRoute
  '/_authenticated/organization/billing': typeof AuthenticatedOrganizationBillingRoute
  '/_authenticated/organization/edit': typeof AuthenticatedOrganizationEditRoute
  '/_authenticated/organization/integration': typeof AuthenticatedOrganizationIntegrationRoute
  '/_authenticated/schedule/$scheduleId': typeof AuthenticatedScheduleScheduleIdRouteWithChildren
  '/_authenticated/schedule/create': typeof AuthenticatedScheduleCreateRoute
  '/_authenticated/user/edit': typeof AuthenticatedUserEditRouteWithChildren
  '/_public/auth/google': typeof PublicAuthGoogleRoute
  '/_public/organization/join': typeof PublicOrganizationJoinRoute
  '/_public/organization/new': typeof PublicOrganizationNewRoute
  '/_authenticated/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/_authenticated/me/': typeof AuthenticatedMeIndexRoute
  '/_authenticated/member/': typeof AuthenticatedMemberIndexRoute
  '/_authenticated/schedule/': typeof AuthenticatedScheduleIndexRoute
  '/_authenticated/schedule/$scheduleId/analytics': typeof AuthenticatedScheduleScheduleIdAnalyticsRoute
  '/_authenticated/schedule/$scheduleId/automations': typeof AuthenticatedScheduleScheduleIdAutomationsRoute
  '/_authenticated/schedule/$scheduleId/details': typeof AuthenticatedScheduleScheduleIdDetailsRoute
  '/_authenticated/schedule/$scheduleId/edit': typeof AuthenticatedScheduleScheduleIdEditRoute
  '/_authenticated/user/edit/account': typeof AuthenticatedUserEditAccountRoute
  '/_authenticated/user/edit/security': typeof AuthenticatedUserEditSecurityRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/invitation'
    | '/logout'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/verify'
    | '/me/feedback'
    | '/organization/billing'
    | '/organization/edit'
    | '/organization/integration'
    | '/schedule/$scheduleId'
    | '/schedule/create'
    | '/user/edit'
    | '/auth/google'
    | '/organization/join'
    | '/organization/new'
    | '/dashboard'
    | '/me'
    | '/member'
    | '/schedule'
    | '/schedule/$scheduleId/analytics'
    | '/schedule/$scheduleId/automations'
    | '/schedule/$scheduleId/details'
    | '/schedule/$scheduleId/edit'
    | '/user/edit/account'
    | '/user/edit/security'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/invitation'
    | '/logout'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/verify'
    | '/me/feedback'
    | '/organization/billing'
    | '/organization/edit'
    | '/organization/integration'
    | '/schedule/$scheduleId'
    | '/schedule/create'
    | '/user/edit'
    | '/auth/google'
    | '/organization/join'
    | '/organization/new'
    | '/dashboard'
    | '/me'
    | '/member'
    | '/schedule'
    | '/schedule/$scheduleId/analytics'
    | '/schedule/$scheduleId/automations'
    | '/schedule/$scheduleId/details'
    | '/schedule/$scheduleId/edit'
    | '/user/edit/account'
    | '/user/edit/security'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/_public'
    | '/invitation'
    | '/_authenticated/logout'
    | '/_public/login'
    | '/_public/reset-password'
    | '/_public/signup'
    | '/_public/verify'
    | '/_authenticated/me/feedback'
    | '/_authenticated/organization/billing'
    | '/_authenticated/organization/edit'
    | '/_authenticated/organization/integration'
    | '/_authenticated/schedule/$scheduleId'
    | '/_authenticated/schedule/create'
    | '/_authenticated/user/edit'
    | '/_public/auth/google'
    | '/_public/organization/join'
    | '/_public/organization/new'
    | '/_authenticated/dashboard/'
    | '/_authenticated/me/'
    | '/_authenticated/member/'
    | '/_authenticated/schedule/'
    | '/_authenticated/schedule/$scheduleId/analytics'
    | '/_authenticated/schedule/$scheduleId/automations'
    | '/_authenticated/schedule/$scheduleId/details'
    | '/_authenticated/schedule/$scheduleId/edit'
    | '/_authenticated/user/edit/account'
    | '/_authenticated/user/edit/security'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
  InvitationRoute: typeof InvitationRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/invitation': {
      id: '/invitation'
      path: '/invitation'
      fullPath: '/invitation'
      preLoaderRoute: typeof InvitationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/verify': {
      id: '/_public/verify'
      path: '/verify'
      fullPath: '/verify'
      preLoaderRoute: typeof PublicVerifyRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/signup': {
      id: '/_public/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof PublicSignupRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/reset-password': {
      id: '/_public/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof PublicResetPasswordRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_authenticated/logout': {
      id: '/_authenticated/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof AuthenticatedLogoutRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/schedule/': {
      id: '/_authenticated/schedule/'
      path: '/schedule'
      fullPath: '/schedule'
      preLoaderRoute: typeof AuthenticatedScheduleIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/member/': {
      id: '/_authenticated/member/'
      path: '/member'
      fullPath: '/member'
      preLoaderRoute: typeof AuthenticatedMemberIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/me/': {
      id: '/_authenticated/me/'
      path: '/me'
      fullPath: '/me'
      preLoaderRoute: typeof AuthenticatedMeIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard/': {
      id: '/_authenticated/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_public/organization/new': {
      id: '/_public/organization/new'
      path: '/organization/new'
      fullPath: '/organization/new'
      preLoaderRoute: typeof PublicOrganizationNewRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/organization/join': {
      id: '/_public/organization/join'
      path: '/organization/join'
      fullPath: '/organization/join'
      preLoaderRoute: typeof PublicOrganizationJoinRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/auth/google': {
      id: '/_public/auth/google'
      path: '/auth/google'
      fullPath: '/auth/google'
      preLoaderRoute: typeof PublicAuthGoogleRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_authenticated/user/edit': {
      id: '/_authenticated/user/edit'
      path: '/user/edit'
      fullPath: '/user/edit'
      preLoaderRoute: typeof AuthenticatedUserEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/schedule/create': {
      id: '/_authenticated/schedule/create'
      path: '/schedule/create'
      fullPath: '/schedule/create'
      preLoaderRoute: typeof AuthenticatedScheduleCreateRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/schedule/$scheduleId': {
      id: '/_authenticated/schedule/$scheduleId'
      path: '/schedule/$scheduleId'
      fullPath: '/schedule/$scheduleId'
      preLoaderRoute: typeof AuthenticatedScheduleScheduleIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/organization/integration': {
      id: '/_authenticated/organization/integration'
      path: '/organization/integration'
      fullPath: '/organization/integration'
      preLoaderRoute: typeof AuthenticatedOrganizationIntegrationRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/organization/edit': {
      id: '/_authenticated/organization/edit'
      path: '/organization/edit'
      fullPath: '/organization/edit'
      preLoaderRoute: typeof AuthenticatedOrganizationEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/organization/billing': {
      id: '/_authenticated/organization/billing'
      path: '/organization/billing'
      fullPath: '/organization/billing'
      preLoaderRoute: typeof AuthenticatedOrganizationBillingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/me/feedback': {
      id: '/_authenticated/me/feedback'
      path: '/me/feedback'
      fullPath: '/me/feedback'
      preLoaderRoute: typeof AuthenticatedMeFeedbackRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/user/edit/security': {
      id: '/_authenticated/user/edit/security'
      path: '/security'
      fullPath: '/user/edit/security'
      preLoaderRoute: typeof AuthenticatedUserEditSecurityRouteImport
      parentRoute: typeof AuthenticatedUserEditRoute
    }
    '/_authenticated/user/edit/account': {
      id: '/_authenticated/user/edit/account'
      path: '/account'
      fullPath: '/user/edit/account'
      preLoaderRoute: typeof AuthenticatedUserEditAccountRouteImport
      parentRoute: typeof AuthenticatedUserEditRoute
    }
    '/_authenticated/schedule/$scheduleId/edit': {
      id: '/_authenticated/schedule/$scheduleId/edit'
      path: '/edit'
      fullPath: '/schedule/$scheduleId/edit'
      preLoaderRoute: typeof AuthenticatedScheduleScheduleIdEditRouteImport
      parentRoute: typeof AuthenticatedScheduleScheduleIdRoute
    }
    '/_authenticated/schedule/$scheduleId/details': {
      id: '/_authenticated/schedule/$scheduleId/details'
      path: '/details'
      fullPath: '/schedule/$scheduleId/details'
      preLoaderRoute: typeof AuthenticatedScheduleScheduleIdDetailsRouteImport
      parentRoute: typeof AuthenticatedScheduleScheduleIdRoute
    }
    '/_authenticated/schedule/$scheduleId/automations': {
      id: '/_authenticated/schedule/$scheduleId/automations'
      path: '/automations'
      fullPath: '/schedule/$scheduleId/automations'
      preLoaderRoute: typeof AuthenticatedScheduleScheduleIdAutomationsRouteImport
      parentRoute: typeof AuthenticatedScheduleScheduleIdRoute
    }
    '/_authenticated/schedule/$scheduleId/analytics': {
      id: '/_authenticated/schedule/$scheduleId/analytics'
      path: '/analytics'
      fullPath: '/schedule/$scheduleId/analytics'
      preLoaderRoute: typeof AuthenticatedScheduleScheduleIdAnalyticsRouteImport
      parentRoute: typeof AuthenticatedScheduleScheduleIdRoute
    }
  }
}

interface AuthenticatedScheduleScheduleIdRouteChildren {
  AuthenticatedScheduleScheduleIdAnalyticsRoute: typeof AuthenticatedScheduleScheduleIdAnalyticsRoute
  AuthenticatedScheduleScheduleIdAutomationsRoute: typeof AuthenticatedScheduleScheduleIdAutomationsRoute
  AuthenticatedScheduleScheduleIdDetailsRoute: typeof AuthenticatedScheduleScheduleIdDetailsRoute
  AuthenticatedScheduleScheduleIdEditRoute: typeof AuthenticatedScheduleScheduleIdEditRoute
}

const AuthenticatedScheduleScheduleIdRouteChildren: AuthenticatedScheduleScheduleIdRouteChildren =
  {
    AuthenticatedScheduleScheduleIdAnalyticsRoute:
      AuthenticatedScheduleScheduleIdAnalyticsRoute,
    AuthenticatedScheduleScheduleIdAutomationsRoute:
      AuthenticatedScheduleScheduleIdAutomationsRoute,
    AuthenticatedScheduleScheduleIdDetailsRoute:
      AuthenticatedScheduleScheduleIdDetailsRoute,
    AuthenticatedScheduleScheduleIdEditRoute:
      AuthenticatedScheduleScheduleIdEditRoute,
  }

const AuthenticatedScheduleScheduleIdRouteWithChildren =
  AuthenticatedScheduleScheduleIdRoute._addFileChildren(
    AuthenticatedScheduleScheduleIdRouteChildren,
  )

interface AuthenticatedUserEditRouteChildren {
  AuthenticatedUserEditAccountRoute: typeof AuthenticatedUserEditAccountRoute
  AuthenticatedUserEditSecurityRoute: typeof AuthenticatedUserEditSecurityRoute
}

const AuthenticatedUserEditRouteChildren: AuthenticatedUserEditRouteChildren = {
  AuthenticatedUserEditAccountRoute: AuthenticatedUserEditAccountRoute,
  AuthenticatedUserEditSecurityRoute: AuthenticatedUserEditSecurityRoute,
}

const AuthenticatedUserEditRouteWithChildren =
  AuthenticatedUserEditRoute._addFileChildren(
    AuthenticatedUserEditRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedLogoutRoute: typeof AuthenticatedLogoutRoute
  AuthenticatedMeFeedbackRoute: typeof AuthenticatedMeFeedbackRoute
  AuthenticatedOrganizationBillingRoute: typeof AuthenticatedOrganizationBillingRoute
  AuthenticatedOrganizationEditRoute: typeof AuthenticatedOrganizationEditRoute
  AuthenticatedOrganizationIntegrationRoute: typeof AuthenticatedOrganizationIntegrationRoute
  AuthenticatedScheduleScheduleIdRoute: typeof AuthenticatedScheduleScheduleIdRouteWithChildren
  AuthenticatedScheduleCreateRoute: typeof AuthenticatedScheduleCreateRoute
  AuthenticatedUserEditRoute: typeof AuthenticatedUserEditRouteWithChildren
  AuthenticatedDashboardIndexRoute: typeof AuthenticatedDashboardIndexRoute
  AuthenticatedMeIndexRoute: typeof AuthenticatedMeIndexRoute
  AuthenticatedMemberIndexRoute: typeof AuthenticatedMemberIndexRoute
  AuthenticatedScheduleIndexRoute: typeof AuthenticatedScheduleIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedLogoutRoute: AuthenticatedLogoutRoute,
  AuthenticatedMeFeedbackRoute: AuthenticatedMeFeedbackRoute,
  AuthenticatedOrganizationBillingRoute: AuthenticatedOrganizationBillingRoute,
  AuthenticatedOrganizationEditRoute: AuthenticatedOrganizationEditRoute,
  AuthenticatedOrganizationIntegrationRoute:
    AuthenticatedOrganizationIntegrationRoute,
  AuthenticatedScheduleScheduleIdRoute:
    AuthenticatedScheduleScheduleIdRouteWithChildren,
  AuthenticatedScheduleCreateRoute: AuthenticatedScheduleCreateRoute,
  AuthenticatedUserEditRoute: AuthenticatedUserEditRouteWithChildren,
  AuthenticatedDashboardIndexRoute: AuthenticatedDashboardIndexRoute,
  AuthenticatedMeIndexRoute: AuthenticatedMeIndexRoute,
  AuthenticatedMemberIndexRoute: AuthenticatedMemberIndexRoute,
  AuthenticatedScheduleIndexRoute: AuthenticatedScheduleIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface PublicRouteChildren {
  PublicLoginRoute: typeof PublicLoginRoute
  PublicResetPasswordRoute: typeof PublicResetPasswordRoute
  PublicSignupRoute: typeof PublicSignupRoute
  PublicVerifyRoute: typeof PublicVerifyRoute
  PublicAuthGoogleRoute: typeof PublicAuthGoogleRoute
  PublicOrganizationJoinRoute: typeof PublicOrganizationJoinRoute
  PublicOrganizationNewRoute: typeof PublicOrganizationNewRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicLoginRoute: PublicLoginRoute,
  PublicResetPasswordRoute: PublicResetPasswordRoute,
  PublicSignupRoute: PublicSignupRoute,
  PublicVerifyRoute: PublicVerifyRoute,
  PublicAuthGoogleRoute: PublicAuthGoogleRoute,
  PublicOrganizationJoinRoute: PublicOrganizationJoinRoute,
  PublicOrganizationNewRoute: PublicOrganizationNewRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
  InvitationRoute: InvitationRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
